<template>
  <div class="full-footer" :class="{ 'open': open }">
    <div class="full-footer__content">
      <div class="full-footer__content-left">
        <img class="full-footer__logo" src="/static/vector/footer-logo.svg" alt="Zonin.">
        <span>
          Via Borgolecco, 9 - 36053 Gambellara (Vicenza) - Tel. 0444 640111 - Fax 0444 640204 - info@zonin.it . P.Iva 00152380242
        </span>
      </div>
      <div class="full-footer__content-right">
        <a href="#">
          <span>Copyright</span>
        </a>
        &nbsp;&nbsp;.&nbsp;&nbsp;
        <a href="/privacy.html">
          <span>Privacy</span>
        </a>
      </div>
    </div>

    <div
      class="full-footer__icon"
      @click="toggleFooter"
      data-apollo-hover
      data-apollo-hover-animation="scale-center"
    >
      <div class="full-footer__icon-inner"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FullFooter',

  data() {
    return {
      open: false,
    };
  },

  methods: {
    toggleFooter() {
      this.open = !this.open;
    },
  },
};
</script>

<style lang="scss" scoped>
.full-footer {
  @include mq($until: ipadL) {
    display: none;
  }

  &__icon {
    position: relative;
    top: 10px;
    width: 20px;
    height: 20px;
    border-radius: 100%;
    border: 1px solid $color-white;
    opacity: 0.5;

    display: flex;
    align-items: center;
    justify-content: center;

    z-index: 2;
    cursor: pointer;
    transition: transform .3s $inOutCubic;

    @include mq($until: ds) {
      top: 0px;
    }

    @at-root .page-white & {
      border-color: $color-dark;
    }

    &-inner {
      width: 4px;
      height: 4px;
      border-radius: 100%;
      background-color: $color-white;

      @at-root .page-white & {
        background-color: $color-dark;
      }
    }

    &:hover {
      transform: scale(1.5);
    }

    @include mq($and: $is-touch-device) {
      &:hover {
        transform: none;
      }
    }
  }

  &__logo {
    position: relative;
    bottom: 3px;
    width: 80px;
    display: inline-block;
    margin-right: calc((100vw / 32) * 1);
  }

  &__content {
    position: fixed;
    width: 100%;
    bottom: 0px;
    left: 0px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    background-color: $color-white;
    padding: calc((100vh / 18) * 1) 0px;
    padding-left: calc((100vw / 32) * 2);
    padding-right: calc((100vw / 32) * 2);
    font-family: 'ITC Frankling Gothic';
    color: $color-dark;
    font-size: rem(20px);
    font-size: calc(20px * var(--rw));
    z-index: 1;
    transform: translateY(100%);
    opacity: 0;
    transition: transform .3s $inOutCubic,
                opacity .3s $inOutCubic;

    display: flex;
    align-items: center;
    justify-content: space-between;

    @include mq($until: ds) {
      font-size: rem(16px);
      font-size: calc(16px * var(--rw));
    }
  }

  &.open {
    .full-footer__icon-inner {
      height: 1px;
      width: 8px;
      border-radius: 0px;
    }

    .full-footer__icon {
      border-color: $color-dark;
    }

    .full-footer__icon-inner {
      background-color: $color-dark;
    }

    .full-footer__content {
      transform: translateY(0px);
      opacity: 1;
    }
  }
}
</style>
